<div class="row" *ngIf="widgetType">
  <div class="col-4">
    <label>Min Height</label>
    <input type="number" class="form-control form-control-sm" [(ngModel)]="widget.minHeight" />
  </div>
  <div class="col-4">
    <label>Min Threshold (Hours)</label>
    <input type="number" min="0" max="96" class="form-control form-control-sm" [(ngModel)]="widget.minThresholdHours" />
  </div>
  <div class="col-4">
    <label>Max Threshold (Days)</label>
    <input type="number" min="0" max="365" class="form-control form-control-sm" [(ngModel)]="widget.maxThresholdDays" />
  </div>
  <div class="col-sm-4" *ngIf="siteTypes">
    <label>Associated Site Type</label>
    <input type="string" class="form-control form-control-sm" [(ngModel)]="widget.siteTypeCode" />
  </div>
</div>